import { useState } from 'react';

type RequestCancel = { abortRequest: () => void; abortSignal: () => AbortSignal };

export const useRequestCancel = (): RequestCancel => {
    const [controller, setController] = useState<AbortController>();

    const abortRequest = () => {
        if (controller) {
            controller.abort();
        }
    };

    const abortSignal = (): AbortSignal => {
        const newController = new AbortController();
        setController(newController);
        return newController.signal;
    };

    return { abortRequest, abortSignal };
};
